import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { getMe, login } from "../utils/api";
import { setJSON } from "../utils/cart";

function normalizeUser(u, emailFallback) {
  if (!u) return null;

  const id = u.id ?? u.userId ?? null;

  return {
    id,
    name: String(u.name ?? u.username ?? "").trim() || "User",
    role: String(u.role || "buyer").toLowerCase(),
    email: String(u.email || emailFallback || "").trim() || "—",

    // force safe strings (so UI doesn't render blank)
    contact: String(u.contact ?? "").trim(),
    address: String(u.address ?? "").trim(),
    joined: u.joined ?? "",
    avatar: String(u.avatar ?? "").trim(),
    created_at: u.created_at ?? "",
    updated_at: u.updated_at ?? "",
  };
}

export default function Login({ setToken, setCurrentUser }) {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();

    try {
      setLoading(true);
      setMsg("");

      const out = await login({ email, password });
      const token = out?.token;

      if (!token) throw new Error("Login failed: missing token");
      setToken(token);

      // Prefer login response user
      let u = out?.user;
      if (!u) {
        const me = await getMe(token);
        u = me?.user || null;
      }

      const user = normalizeUser(u, email);
      if (!user?.id) throw new Error("Login failed: missing user info");

      setCurrentUser(user);
      setJSON("currentUser", user);
      setJSON("authUser", user);
      navigate("/");
    } catch (err) {
      setMsg(err?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container pagePadBottom" style={{ maxWidth: 520 }}>
      <div className="card">
        <div style={{ fontWeight: 900, fontSize: 22 }}>Welcome back</div>

        <form
          onSubmit={onSubmit}
          style={{ marginTop: 14, display: "grid", gap: 10 }}
        >
          <div>
            <div className="label">Email</div>
            <input
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>

          <div>
            <div className="label">Password</div>
            <input
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {msg ? (
            <div className="card" style={{ borderLeft: "4px solid #e11d48" }}>
              <div style={{ fontWeight: 900 }}>{msg}</div>
            </div>
          ) : null}

          <button
            className="btnPrimary"
            disabled={loading}
            style={{ justifyContent: "center" }}
          >
            {loading ? "Logging in…" : "Login"}
          </button>
        </form>

        <div className="muted" style={{ marginTop: 12 }}>
          No account? <Link to="/register">Register</Link>
        </div>
      </div>
    </div>
  );
}
